import { useTranslation } from 'react-i18next';
import { Bug, Globe, Mail, MessageSquareText, Phone, Plug, Puzzle, Users } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/** D-146 (Q-102) — the icon of a ticket's source ("manual" / unknown: none). */
const ICONS: Record<string, LucideIcon> = {
  phone: Phone,
  email: Mail,
  whatsapp: MessageSquareText,
  meeting: Users,
  portal: Globe,
  bug_report: Bug,
  integration: Plug,
  // P-64 (D-197): opened from the customer Chrome extension.
  extension: Puzzle,
};

export function hasSourceIcon(source: string | null | undefined): boolean {
  return !!source && source in ICONS;
}

export default function TicketSourceIcon({ source, size = 14, withLabel = false }: { source?: string | null; size?: number; withLabel?: boolean }) {
  const { t } = useTranslation();
  if (!source || !(source in ICONS)) return null;
  const Icon = ICONS[source];
  const label = t(`ticketSource.${source}`);
  return (
    <span className="inline-flex items-center gap-1 text-text-3" title={`${t('ticketSource.label')}: ${label}`}>
      <Icon size={size} strokeWidth={1.75} aria-hidden="true" />
      {withLabel ? <span>{label}</span> : <span className="sr-only">{`${t('ticketSource.label')}: ${label}`}</span>}
    </span>
  );
}
